// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { infoProps } from "@store/Themes/common/props/info";
/* Starter Custom Code - End */

export interface OrderDetailsShippingMethodStyles {
    titleText?: TypographyProps;
    description?: TypographyProps;
    wrapper?: InjectableCss;
}

export const shippingMethodStyles: OrderDetailsShippingMethodStyles = {
    titleText: infoProps.label,
    description: infoProps.value,
};

const styles = shippingMethodStyles;

const OrderDetailsShippingMethod: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    /* Store Custom Code - Start */
    const shipCode = order.shipCode?.trim() ?? "";
    const shipViaDescription = order.shipViaDescription?.trim() ?? "";

    const isShippingContext = order.fulfillmentMethod === FulfillmentMethod.Ship || !order.fulfillmentMethod;
    const hasShippingMethod = isShippingContext && (shipCode.length > 0 || shipViaDescription.length > 0);
    /* Store Custom Code - End */

    if (!hasShippingMethod) {
        return null;
    }

    /* Store Custom Code - Start */
    const shippingText =
        shipCode && shipViaDescription ? `${shipCode} - ${shipViaDescription}` : shipCode || shipViaDescription;
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Store Custom Code - Start */}
            <Typography {...styles.titleText}>{translate("Shipping Term")}</Typography>
            <Typography {...styles.description}>{shippingText}</Typography>
            {/* Store Custom Code - End */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShippingMethod,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
